__turbopack_context__.v({
  "buttons-container": "dqpRegistration-module-scss-module__gUgXoq__buttons-container",
  "form-container": "dqpRegistration-module-scss-module__gUgXoq__form-container",
  "grid": "dqpRegistration-module-scss-module__gUgXoq__grid",
  "grid--frozen": "dqpRegistration-module-scss-module__gUgXoq__grid--frozen",
});
